import { Category } from './types';
import {
  CATEGORY_EXHIBIT_TYPE,
  CATEGORY_EXPOSE_LOCATION_TYPE,
  CATEGORY_SORT_TYPE,
  CATEGORY_STATUS_TYPE,
  CATEGORY_TYPE,
} from '../../../constants/service/app/categoryConstants';

export const GET_CATEGORY_DETAIL_INITIAL_DATA: { category: Category } = {
  category: {
    id: 0,
    parentId: null,
    type: CATEGORY_TYPE.GENERAL,
    name: '',
    subCategoryCount: 0,
    productCount: 0,
    status: CATEGORY_STATUS_TYPE.INACTIVE,
    isExhibit: CATEGORY_EXHIBIT_TYPE.INEXHIBIT,
    exposureType: CATEGORY_EXPOSE_LOCATION_TYPE.COMMON,
    sortType: CATEGORY_SORT_TYPE.TREND,
    memo: null,
    createDate: '',
    updateDate: '',
    categoryAttachments: [],
  },
};

export const CATEGORY_HISTORY_REQUEST_PARAM = {
  first: { orderBy: 'asc', pageSize: 1 },
  last: { orderBy: 'desc', pageSize: 1 },
};
